<div class="deep-linking-option">
  <div class="deep-linking-option-header">
    <img src="{{getLogoUrl()}}" class="deep-linking-options-logo">
    <div class="option-price">

      <div class="option-price-box">
        <div class="price">
          <span *ngIf="hasPromo" class="promo-original-price">
            <ng-container *ngIf="currentLang !== 'fr'" class="currency">€</ng-container>
            <span>{{textIntegerPart}}{{textDecimalPart}}</span>
            <ng-container *ngIf="currentLang === 'fr'" class="currency left">€</ng-container>
          </span>

          <div class="price-left">
            <span class="currency" *ngIf="currentLang !=='fr'">€</span>
            <span>{{priceBeforeComma}}</span>
          </div>
          <div class="price-right">
            <span class="comma">{{getPriceTextDecimalPart}}</span>
            <span *ngIf="currentLang ==='fr'" class="currency">€</span>
            <div class="after">/<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span></div>
          </div>
        </div>
        <span *ngIf="promoLabel" class="promo-label" [translate]="'eos-tv-shop-ii.lbl.' + promoLabel"
              [translateParams]="{ duration: promoDuration }">gedurende x maand(en)</span>
      </div>
    </div>
  </div>
  <div class="option-body">
    <div class="option-description-bullets"
         [innerHTML]="'eos-tv-shop-ii.text.deep-linking-list-'.concat(rscOmapiId) | translate">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer auctor magna.
    </div>
    <div class="bottom">
      <app-order-button
        class="smaller"
        [x]="x"
        [y]="0"
        [active]="x===0"
        [pack]="pack"
        [isDeepLinking]="true"
        [isOrderable]="true"
        (emitOnBack)="onBack()"
        [ownerComponent]="ownerComponent"
        (emitOnEnterPressed)="emitOnEnterPressed($event)"
        [buttonTextKey]="'eos-tv-shop-ii.lbl.nu-abonneren'">
      </app-order-button>
      <app-order-button
        class="smaller"
        [x]="x+1"
        [y]="0"
        [pack]="pack"
        [isDeepLinking]="true"
        [isOrderable]="false"
        (emitOnBack)="onBack()"
        [ownerComponent]="ownerComponent"
        (emitOnEnterPressed)="navigateToDetailPage()"
        [buttonTextKey]="'eos-tv-shop-ii.lbl.know-more'">
      </app-order-button>
    </div>
  </div>
  <app-ordering-modal-manager [order]="order" #orderModal [packageName]="productName()"></app-ordering-modal-manager>
</div>
